module.exports = __webpack_public_path__ + "cec9dd5540b348075997b9c5e8361fca.svg";